export enum TwoFactorAuthenticationTypes {
  None = 0,
  Email = 1,
  TOTP = 2,
}

export enum LoginType {
  Normal = 0,
  Impersonation = 1,
  ExternalAccess = 2,
}

export enum CaseStatusTypes {
  All = 0,
  Open = 1,
  OnHold = 2,
  Closed = 3,
}

export enum JobStatusFilterTypes {
  All = 0,
  InProgress = 1,
  Other = 2,
  Closed = 3,
}

export enum ProposedWorkFilterTypes {
  All = 0,
  InProgress = 1,
  Closed = 2,
}

export enum ProposedWorkStatusTypes {
  "Awaiting Quotes" = 1,
  "Requesting Funds",
  "Awaiting Client Funds",
  "Work In Progress",
  "Complete Invoice Received",
  "Canceled Before Funds Received",
  "Canceled Funds Returned",
  "Cancelled due to lack of funds",
  "Awaiting Client Votes",
}

export enum JobStatusTypes {
  All = "All",
  RAMsRequested = "RAMs Requested",
  NoActionTaken = "No Action Taken",
  EstimateRequested = "Estimate Requested",
  ProposeWorks = "Propose Works",
  InternalCompleted = "Internal Completed",
  CompletedAndAwaitingInvoice = "Completed and Awaiting Invoice",
  ExternalCompleted = "External Completed",
  JobInProgress = "Job In Progress",
  AuthorisationRequired = "Authorisation Required",
  PhoneSubContractor = "Phone Sub-Contractor",
}

export enum FilterTimeFrames {
  None = "None",
  Today = "Today",
  ThreeDays = "Three Days",
  OneWeek = "1 Week",
  TwoWeeks = "2 Weeks",
  OneMonth = "1 Month",
  ThreeMonths = "3 Months",
  SixMonths = "6 Months",
  OneYear = "1 Year",
  ThreeYears = "3 Years",
  All = "All time",
}
